import React, { useContext } from 'react';
import { useConfigService, ExperienceContext, } from '@thd-nucleus/experience-context';
import { MilitaryBanner } from '@thd-olt-component-react/ocm_pd_component_myaccount-military-banner';
import { useDataModel, params, number as numberType, bool as boolType, id as idType, } from '@thd-nucleus/data-sources';
import { useCustomerInfo } from '../../hooks/use-customer-info';
export var DashboardMilitaryBanner = function () {
    var _a;
    var isMilitaryBannerEnabled = useConfigService('DASHBOARD_MILITARY_BANNER_ENABLED');
    var channel = useContext(ExperienceContext).channel;
    var channelId = channel === 'mobile' ? 2 : 1;
    var _b = useCustomerInfo(), customerAccountId = _b.svocID, userId = _b.userID;
    var militaryDiscountData = useDataModel('militaryDiscountDetails', {
        variables: { userId: userId, customerAccountId: customerAccountId, channelId: channelId },
        ssr: false,
        skip: !userId || !customerAccountId || !isMilitaryBannerEnabled,
        context: { withAuth: true },
    }).data;
    var hasMilitaryBenefit = ((_a = militaryDiscountData === null || militaryDiscountData === void 0 ? void 0 : militaryDiscountData.militaryDiscountDetails) === null || _a === void 0 ? void 0 : _a.isEnrolled) || false;
    return isMilitaryBannerEnabled && hasMilitaryBenefit ? (React.createElement(MilitaryBanner, null)) : null;
};
DashboardMilitaryBanner.displayName = 'DashboardMilitaryBanner';
DashboardMilitaryBanner.dataModel = {
    militaryDiscountDetails: params({
        userId: idType().isRequired(),
        customerAccountId: idType().isRequired(),
        channelId: numberType().isRequired(),
    }).shape({
        isEnrolled: boolType(),
    }),
};
